import axios from 'axios';

let CmsUrl = '';
try {
    CmsUrl = window.top.cmsAppVm && window.top.location.href;
} catch (e) {}
// federated
export const FEDERATED_DEBUG =
    /debug=federated/.test(window.location.href) ||
    /debug=federated/.test(CmsUrl);

function loadComponent(scope, module) {
    return async () => {
        // Initializes the share scope. This fills it with known provided modules from this build and all remotes
        // eslint-disable-next-line no-undef
        await __webpack_init_sharing__('default');
        const container = window[scope]; // or get the container somewhere else
        // Initialize the container, it may provide shared modules
        // eslint-disable-next-line no-undef
        await container.init(__webpack_share_scopes__.default);
        const factory = await window[scope].get(module);
        const Module = factory();

        return Module;
    };
}

let urlCache = new Set();

const loadScript = async url => {
    if (!url) return Promise.reject('url is required');
    if (urlCache.has(url)) {
        return;
    }
    const element = document.createElement('script');
    element.src = url;
    element.type = 'text/javascript';
    element.async = true;

    return new Promise((resolve, reject) => {
        element.onload = () => {
            urlCache.add(url);
            resolve();
        };
        element.onerror = reject;
        document.head.appendChild(element);
    });
};

const componentCache = new Map();
export const getFederatedComponent = async function ({ url, scope, module }) {
    const key = `${url}-${scope}-${module}`;
    let cache = componentCache.get(key);
    if (cache) {
        return cache;
    }
    await loadScript(url);
    let Comp = loadComponent(scope, module);
    componentCache.set(key, Comp);
    return Comp;
};

// 加载方法
export const getFederatedMethods = async function ({ url, scope, module }) {
    let com = await getFederatedComponent({
        url,
        scope,
        module
    });
    let { default: methods } = await com();
    return methods;
};

// 加载 js 组件
export const getFederatedMethodsComponent = async function (
    vm,
    { url, scope, module },
    ...mountParams
) {
    let child = await getFederatedMethods({
        url,
        scope,
        module
    });
    child.mount(...mountParams);
    vm?.$once?.('hook:beforeDestroy', function () {
        child.unmount && child.unmount();
    });
    return child;
};

// 获取 url
export const getFederatedJsUrl = async function ({ appid, scope }) {
    let res = await axios.get(`/api/site-plugin/version/getAppCurrentVersion`, {
        params: { appId: appid }
    });
    try {
        let data = JSON.parse(res.data.data);
        let federation = data.federation || [];
        for (let i = 0; i < federation.length; i++) {
            let item = federation[i];
            if (item.scope === scope) {
                return item.remoteUrl || '';
            }
        }
        console.log(federation, scope);
    } catch (e) {
        console.error(e);
    }
    return '';
};

// 获取远程的方法
export const getFederatedMethodsByAppId = async function ({
    appid,
    scope,
    module,
    url
}) {
    if (!(FEDERATED_DEBUG && url)) {
        // 只有在调试模式，且 URL 存的时候，才有效
        url = await getFederatedJsUrl({ appid, scope });
    }
    if (!url) {
        return Promise.reject('remote url is empty');
    }
    return getFederatedMethods({ url, scope, module });
};

// 获取远程方法组件
export const getFederatedMethodsComponentByAppId = async function (
    vm,
    { appid, scope, module, url },
    ...mountParams
) {
    if (!(FEDERATED_DEBUG && url)) {
        // 只有在调试模式，且 URL 存的时候，才有效
        url = await getFederatedJsUrl({ appid, scope });
    }
    if (!url) {
        return Promise.reject('remote url is empty');
    }
    return getFederatedMethodsComponent(
        vm,
        { url, appid, scope, module },
        ...mountParams
    );
};
